import styled from '@emotion/styled';
import {Text} from '@chakra-ui/react';

export const StyledSubheaderText = styled(Text)`
	font-weight: 600;
	font-style: 'Open-Sans';
	width: 100%;
`;
